import fp from "lodash/fp";
import { required, minLength, maxLength, maxLength9 } from "validators";

export const FORM_NAME = "creditHistory";
export const BANK_NAME_FIELD = "bank";
export const BANK_ROUTING_FIELD = "routing";
export const ACCOUNT_NUMBER_FIELD = "account";

export const validateBankRouting = [required, maxLength9];

export const validateAccountNumber = [required, minLength(6), maxLength(17)];

export const warnCreditHistory = (values, { banks }) => {
	const warnings = {};

	const bankRoutingValue = values[BANK_ROUTING_FIELD];

	if (bankRoutingValue) {
		const bankWithRoutingExists = fp.find(
			["routing", bankRoutingValue],
			banks,
		);

		if (!bankWithRoutingExists) {
			warnings[BANK_ROUTING_FIELD] = "Routing does not match our records";
		}
	}

	const bankNameValue = values[BANK_NAME_FIELD];

	if (bankNameValue && !warnings[BANK_ROUTING_FIELD]) {
		const bankWithNameExists = fp.find(["bank", bankNameValue], banks);

		if (!bankWithNameExists) {
			warnings[BANK_NAME_FIELD] = "Bank does not match our records";
		}
	}

	return warnings;
};
